import FemaleOnlyQuestions from './FemaleOnlyQuestions';

export default FemaleOnlyQuestions;
